import { DAY_OF_WEEK, FEE_TAX_SETTING } from "./shared";
import { Dayjs } from "dayjs";

export enum DANCE_STYLE {
  BALLET = "Ballet",
  CONTEMPORARY = "Contemporary",
  JAZZ = "Jazz",
  HIP_HIP = "HipHop",
  TAP = "Tap",
  MUSICAL_THEATRE = "MusicalTheatre",
  PRE_SCHOOL = "PreSchool"
}

export interface IDanceClass {
  id: string;
  locationId: string;
  studioId: string;
  name: string;
  danceStyle: DANCE_STYLE;
  dayOfWeek: DAY_OF_WEEK;
  startTime: Dayjs;
  endTime: Dayjs;
  minAge?: number;
  maxAge?: number;
  fee: number;
  feeTaxSetting: FEE_TAX_SETTING;
  inviteOnly: boolean;
}